export const defaultStudioId = 908;
